import { tx } from "@/i18n/tx";
import { BottomNav } from "@/components/BottomNav";
import { useTranslation } from "react-i18next";

export function AppShell({ children, nav = true }) {
  return (
    <div className="anima-backdrop min-h-screen w-full flex justify-center">
      <div className="relative w-full max-w-md min-h-screen bg-transparent">
        <div className={nav ? "pb-[calc(7.5rem+env(safe-area-inset-bottom))]" : ""}>{children}</div>
        {nav && <BottomNav />}
      </div>
    </div>
  );
}

export function Loader({ label }) {
  const { t } = useTranslation();
  return (
    <div className="anima-backdrop min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="w-12 h-12 rounded-full border-2 border-anima-sage/40 border-t-anima-sagedeep animate-spin" />
      <p className="font-serif text-anima-muted text-lg italic">{label || t("common.loader", tx("Un momento di respiro…"))}</p>
    </div>
  );
}
